import React,{useState} from 'react'

export default function MassConversions() {

    /**New change */
    const [g, setG] = useState(0) // - done
    const [kg, setKg] = useState(0)
    const [mg, setMg] = useState(0)
    const [mt, setMt] = useState(0)
    const [o, setO] = useState(0)
    const [p, setP] = useState(0)
    const [st, setSt] = useState(0)
    const [c, setC] = useState(0)

    /**Disabling the mouse wheel */
    const inputFields = document.querySelectorAll('.highlight');
    inputFields.forEach(function(inputField) {
            inputField.addEventListener('wheel', function(event) {
            event.preventDefault();
        });
    })

  return (


    <div>
        <div  style={{display:"flex", justifyContent:"center"}}>
            <h2 style={{color:"#F9D081"}}>Weight Conversions</h2>
        </div>
      <div className="grid-container" style={{backgroundColor:"#o44f44d", marginLeft:"25%", marginRight:"25%"}}>        
            <div  >
                <div><label id="myLabels" htmlFor="number">Grams (g)</label></div>
                
                <input  className='highlight'type="number" 
                value={g}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a);
                    setKg(a*0.001);
                    setMg(a*1000);
                    setMt(a*0.000001);
                    setO(a*0.03527396);
                    setP(a*0.00220462);
                    setSt(a*0.000157473);
                    setC(a*5);
            }}/></div> 


             <div  >
                <div><label id="myLabels" htmlFor="number">Kilograms (kg)</label></div>
                
                <input  className='highlight'type="number" 
                value={kg}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a*1000);
                    setKg(a);
                    setMg(a*1000000);
                    setMt(a*0.001);
                    setO(a*35.27396);
                    setP(a*2.20462);
                    setSt(a*0.157473);
                    setC(a*5000);
            }}/></div>     

<div  >
                <div><label id="myLabels" htmlFor="number">Milligrams (mg)</label></div>
                
                <input  className='highlight'type="number" 
                value={mg}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a*0.001);
                    setKg(a*0.000001);
                    setMg(a);
                    setMt(a*0.000000001);
                    setO(a* 0.00003527396);
                    setP(a*0.00000220462);
                    setSt(a*0.000000157473);
                    setC(a*0.005);
            }}/></div> 


            <div>
                <div><label id="myLabels" htmlFor="number">Metric tonnes (mt)</label></div>
                
                <input  className='highlight'type="number" 
                value={mt}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a*1000000);
                    setKg(a*1000);
                    setMg(a*1000000000);
                    setMt(a);
                    setO(a*35273.96);
                    setP(a*2204.62);
                    setSt(a*157.473);
                    setC(a*5000000);
            }}/></div> 

<div>
                <div><label id="myLabels" htmlFor="number">Ounces (oz)</label></div>
                
                <input  className='highlight'type="number" 
                value={o}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a*28.3495);
                    setKg(a*0.0283495);
                    setMg(a*28,349.5);
                    setMt(a*0.0283495);
                    setO(a);
                    setP(a*0.0625);
                    setSt(a*0.00446429);
                    setC(a*141.748);
            }}/></div> 



            <div>
                <div><label id="myLabels" htmlFor="number">Pounds (lbs)</label></div>
                
                <input  className='highlight'type="number" 
                value={p}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a*28.3495);
                    setKg(a*0.0283495);
                    setMg(a*28,349.5);
                    setMt(a*0.0283495);
                    setO(a*0.0625);
                    setP(a);
                    setSt(a*0.00446429);
                    setC(a*141.748);
            }}/></div> 

                <div>
                <div><label id="myLabels" htmlFor="number">Stones (st)</label></div>
                
                <input  className='highlight'type="number" 
                value={st}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a*6350.29);
                    setKg(a*6.35029);
                    setMg(a*6350290);
                    setMt(a*0.00635029);
                    setO(a*224);
                    setP(a*14);
                    setSt(a);
                    setC(a*31751.5);
            }}/></div> 


<div>
                <div><label id="myLabels" htmlFor="number">Carats (ct)</label></div>
                
                <input  className='highlight'type="number" 
                value={c}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setG(a*0.2);
                    setKg(a*0.0002);
                    setMg(a*200);
                    setMt(a*0.0000002);
                    setO(a*0.00705479);
                    setP(a*0.000440925);
                    setSt(a*0.0000315);
                    setC(a);
            }}/></div> 
        </div> 

        <div  style={{display:"flex", justifyContent:"center"}}>
        <button className='clear-button' onClick={(e) => {
            setG(0);
            setKg(0);
            setMg(0);
            setMt(0);
            setO(0);
            setP(0);
            setSt(0);
            setC(0);
    }}>
        Clear Button
    </button>
        </div>
    </div>


)
}









